import { useEffect } from 'react';
import { socket } from '../providers/socket';
import { EventTypeEnum } from '@matap/shared';

export function useSocketListener(
  event: EventTypeEnum,
  cb: (...args: any[]) => any,
  dependencies: any[] = [], // Default to empty array is a good practice
) {
  useEffect(() => {
    const safeCallback = async (...args: any[]) => {
      const potentialAckCallback = args[args.length - 1];
      const hasAck = typeof potentialAckCallback === 'function';

      try {
        const res = await cb(...args);

        if (hasAck) {
          potentialAckCallback(res);
        }
      } catch (error) {
        console.error(`Error in socket listener for ${event}:`, error);
        if (hasAck) {
          potentialAckCallback({ error: 'Client threw an error' });
        }
      }
    };

    socket.on(event, safeCallback);

    return () => {
      socket.off(event, safeCallback);
    };
  }, dependencies);
}
